import React from 'react'
import PropTypes from 'prop-types'
import ClassificationChips from '../common/ClassificationChips'

function Keywords({ keywords }) {
  return <ClassificationChips items={keywords} />
}

Keywords.propTypes = {
  keywords: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
}

export default Keywords
